import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76a0d1fb"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "info-container"
}

import { withDefaults } from 'vue'
import { DevicePayInfoType } from '@/types/insurance'
import BaseInfoList from './base-info-list.vue'
import CostInfoItem from './cost-info-item.vue'
import DeviceCommonInfoComponent from './device-common-info.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'device-pay-info',
  props: {
    detail: { default: null }
  },
  setup(__props: any) {

const props = __props as { detail: DevicePayInfoType | null };


// console.log('props.detail', props.detail)

return (_ctx: any,_cache: any) => {
  return (props.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(DeviceCommonInfoComponent, {
          info: props.detail.deviceCommonInfo
        }, null, 8, ["info"]),
        _createVNode(BaseInfoList, {
          list: props.detail.serviceInfoList,
          class: "van-hairline--top"
        }, null, 8, ["list"]),
        (props.detail.costInfo?.length)
          ? (_openBlock(), _createBlock(BaseInfoList, {
              key: 0,
              list: props.detail.costInfo,
              listItemJustifyContent: "space-between",
              class: "van-hairline--top",
              labelWidth: 220
            }, null, 8, ["list"]))
          : _createCommentVNode("", true),
        _createVNode(CostInfoItem, {
          class: "van-hairline--top",
          buyInfo: props.detail.buyInfo
        }, null, 8, ["buyInfo"])
      ]))
    : _createCommentVNode("", true)
}
}

})